// Registro del Service Worker SIN recargas automáticas: una nueva versión queda
// "en espera" y solo se aplica cuando el usuario toca el aviso de actualización.
// (Antes: skipWaiting + reload en controllerchange recargaba la app a media captura.)
let userInitiatedUpdate = false;

export function applyUpdate(reg) {
  userInitiatedUpdate = true;
  if (reg?.waiting) {
    reg.waiting.postMessage({ type: 'SKIP_WAITING' });
    // controllerchange hará el reload; fallback por si no llega
    setTimeout(() => window.location.reload(), 2500);
  } else {
    window.location.reload();
  }
}

export function registerSW() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (userInitiatedUpdate) window.location.reload();
  });

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js');
      reg.update().catch(() => {});
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reg.update().catch(() => {});
      });
    } catch (e) {
      console.warn('SW registration failed', e);
    }
  });
}
